import { render } from "./componentTitleFr.vue?vue&type=template&id=32d3491a&scoped=true&ts=true"
import script from "./componentTitleFr.vue?vue&type=script&lang=ts"
export * from "./componentTitleFr.vue?vue&type=script&lang=ts"

import "./componentTitleFr.vue?vue&type=style&index=0&id=32d3491a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d3491a"]])

export default __exports__